import { render, staticRenderFns } from "./SpecialistUserGuides.vue?vue&type=template&id=473615ae"
import script from "./SpecialistUserGuides.vue?vue&type=script&lang=js"
export * from "./SpecialistUserGuides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports